/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResourcePoolRequestStatusType = 'PENDING_APPROVAL' | 'DENIED_APPROVAL' | 'IN_PROGRESS' | 'DONE' | 'FAILED';

export const ResourcePoolRequestStatusType = {

    PENDING_APPROVAL: 'PENDING_APPROVAL' as ResourcePoolRequestStatusType,

    DENIED_APPROVAL: 'DENIED_APPROVAL' as ResourcePoolRequestStatusType,

    IN_PROGRESS: 'IN_PROGRESS' as ResourcePoolRequestStatusType,

    DONE: 'DONE' as ResourcePoolRequestStatusType,

    FAILED: 'FAILED' as ResourcePoolRequestStatusType
};

